//sessionStorage ID
export const USER_TYPE = 'HA-UserType';

export enum UserType {
  Customer = 'customer',
  Prospect = 'prospect',
  Employee = 'employee'
}
